<template>
    <div>

        <v-toolbar dense color="primary" app :clipped-left="clipped" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Finalizar Ordem</v-toolbar-title>

            <v-spacer/>

        </v-toolbar>

        <main v-if="ordem">

            <v-layout row justify-center>
                <v-dialog v-model="dialog" max-width="290">
                    <v-card>
                        <v-card-title class="headline">Localização</v-card-title>
                        <v-card-text>Cliente sem localização, pretende cadastrar a localização neste momento?</v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="green darken-1" flat="flat" @click.native="goBack()">Não</v-btn>
                            <v-btn color="green darken-1" flat="flat" @click.native="openLatLong()">Quero Cadastrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-progress-linear v-if="loading" :indeterminate="loading"/>

            <div v-if="loading">Aguarde carregamento</div>

            <v-stepper v-model="e1" class="elevation-0">

                <v-stepper-header class="elevation-0">
                    <v-stepper-step :complete="e1 > 1" step="1">Name of step 1</v-stepper-step>
                    <v-divider/>
                    <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>
                    <v-divider/>
                    <v-stepper-step step="3">Finalizar</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items style="border-top: #0d47a1 solid thin">

                    <v-stepper-content step="1">
                        <v-card raised flat class="elevation-0" style="height: calc(100vh - 220px)">
                            <h2>MAPA</h2>

                            <br/>
                            <p v-if="mapa">
                                A localização já esta cadastrada.
                                <br/><br/><br/>
                            </p>
                            <p v-else>
                                A localização NÃO esta cadastrada.<br/><br/>Favor cadastrar e informar a localização do cliente
                                <br/><br/><br/>
                            </p>

                            <v-btn color="primary" flat="flat" @click.native="openLatLong()">
                                Cadastrar Posição
                            </v-btn>

                        </v-card>
                        <v-btn color="primary" :disabled="!mapa" @click.native="e1 = 2">AVANÇAR</v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <v-card class="mb-2" flat style="height: calc(100vh - 220px)">
                            <div v-if="!ordem.retirada_equipamento">
                                <h2>ADICIONAR PRODUTOS</h2>

                                <v-layout row grid-list-md>
                                    <v-flex xs9 pa-1>
                                        <v-select
                                            hide-details
                                            :items="all_produtos"
                                            v-model="prod"
                                            item-text="nome"
                                            label="Produtos Utilizados"
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs3 pa-1>
                                        <v-text-field
                                            hide-details
                                            v-model.number="qtde"
                                            :type="'number'"
                                            label="QTDE"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn block small color="primary" :disabled="!qtde || !prod" @click.native="add">
                                            ADICIONAR
                                        </v-btn>
                                    </v-flex>
                                </v-layout>

                                <div pt-6>
                                    <table class="table" >
                                        <tr>
                                            <th style="text-align: left">PRODUTO</th>
                                            <th style="text-align: center">AÇÔES</th>
                                        </tr>
                                        <tr v-for="p of ordem.produtos" :key="p.id_ordem_servico" style="border-top: #0d47a1 solid 1px">
                                            <td style="text-align: left">{{p.nome}}</td>
                                            <td style="text-align: center">
                                                <v-btn icon depressed small color="error">
                                                    <v-icon>remove</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                            </div>
                            <div v-else>
                                <h2>ADICIONAR PRODUTOS</h2>
                                <br/><br/>
                                <p>Ordem de retirada, favor avançar.</p>
                            </div>
                        </v-card>

                        <v-btn color="primary" @click.native="e1 = 3">AVANÇAR</v-btn>

                        <v-btn flat @click.native="e1 = 1">
                            VOLTAR
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <v-card class="mb-2" flat style="height: calc(100vh - 220px)">

                            <v-form v-model="valid" ref="form" lazy-validation v-if="!loading">

                                <v-text-field
                                    name="input-7-2"
                                    label="DIAGNÓSTICO / OBS"
                                    v-model="dados.diagnostico"
                                    rows="8"
                                    class="input-group--focused"
                                    multi-line
                                />

                                <br/>
                                <v-checkbox
                                    label="Tudo checado no cliente"
                                    v-model="dados.checkbox"
                                    :rules="[v => !!v || 'Você precisa confirmar!']"
                                    required
                                />

                            </v-form>

                        </v-card>

                        <v-btn color="primary" @click="submit" :disabled="!dados.checkbox" >
                            <v-icon dark left>done_all</v-icon> FINALIZAR
                        </v-btn>

                        <v-btn flat @click.native="e1 = 2">VOLTAR</v-btn>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </main>
    </div>

</template>

<script>
    /* eslint-disable camelcase */

    import { Ordens } from "../class/ordens";
    import { Sync } from "../class/sync";
    import { Me } from "../class/me";

    export default {
        name: "finalizar-internet",
        data: () => ({
            valid: false,
            ordem: null,
            e1: 0,
            qtde: 0,
            mapa: true,
            prod: null,
            all_produtos: [],
            dialog: false,
            loading: true,
            clipped: true,
            produtos_alterados: false,
            me: null,
            items: [],
            dados: {
                id_ordem_servico: null,
                caixa: null,
                diagnostico: null,
                action: "CLOSE_ORDEM",
                checkbox: false
            }
        }),
        async beforeMount () {
            this.me = await Me.get();
            console.log(this.me);

            this.all_produtos.push({
                codigo_produto: "WIFI",
                nome: "Roteador wireless"
            });

            this.all_produtos.push({
                nome: "Rede Óptica de Distribuição",
                codigo_produto: "ONU"
            });

            this.all_produtos.push({
                nome: "Antena de rádio receptor",
                codigo_produto: "RADIO"
            });

            this.all_produtos.push({
                nome: "Fonte POE",
                codigo_produto: "FONTE"
            });

            this.all_produtos.push({
                nome: "Cabo UTP",
                codigo_produto: "UTP"
            });

            this.all_produtos.push({
                nome: "Cabo DROP",
                codigo_produto: "DROP"
            });

            this.all_produtos.push({
                nome: "Cabo FLAT",
                codigo_produto: "FLAT"
            });

            this.all_produtos.push({
                nome: "Caixa SWITCH",
                codigo_produto: "SWITCH"
            });

            this.all_produtos.push({
                nome: "Caixa PACPON",
                codigo_produto: "PACPON"
            });

            this.all_produtos.push({
                nome: "Caixa CTO",
                codigo_produto: "CTO"
            });

            Ordens
                .get(parseInt(this.$route.params.id))
                .then((ordem) => {
                    console.log(ordem);
                    if (ordem) {
                        this.ordem = ordem;
                        this.dados.id_ordem_servico = ordem.id_ordem_servico;
                        if (!ordem.retirada_equipamento && (!ordem.latlng || !ordem.latlng.latitude)) {
                            this.dialog = true;
                            this.mapa = false;
                        } else {
                            this.loading = false;
                        }
                    } else {
                        this.goBack();
                    }
                })
                .catch((err) => console.error(err));
        },
        methods: {
            add () {
                let { nome, codigo_produto } = this.prod;
                this.del(codigo_produto);
                this.ordem.produtos.push({
                    nome,
                    codigo_produto,
                    qtde: this.qtde
                });
                this.produtos_alterados = true;
            },
            del (tel) {
                this.ordem.produtos.forEach((e) => {
                    if (e.codigo_produto === tel) {
                        this.ordem.produtos.splice(this.ordem.produtos.indexOf(e), 1);
                        this.produtos_alterados = true;
                    }
                });
            },
            openLatLong: function () {
                this.$router.push("/latlong/" + this.$route.params.id);
            },
            goBack: function () {
                this.$router.push("/ver-ordem/" + this.$route.params.id);
            },
            async submit () {
                if (this.$refs.form.validate()) {
                    console.log("OK");
                    try {
                        if (this.produtos_alterados) {
                            await this.sendProduto();
                        }
                        let key = await Sync.add(this.dados);
                        await Sync.syncOne(key, this.$socket);
                        await Ordens.del(this.ordem.id_ordem_servico);
                        this.goBack();
                    } catch (e) {
                        console.error(e);
                    }
                }
            },
            async sendProduto () {
                let param = {
                    produtos: this.ordem.produtos,
                    id_contratos_servicos: this.ordem.id_contratos_servicos,
                    id_ordem_servico: this.ordem.id_ordem_servico,
                    tecnico: {
                        id_funcionario: this.me.id_funcionario,
                        nome: this.me.nome
                    },
                    action: "SYNC_PRODUTOS"
                };
                let key = await Sync.add(param);
                await Sync.syncOne(key, this.$socket);
                await Ordens.setProdutos(this.ordem.id_ordem_servico, this.ordem.produtos);
            }
        }
    };
</script>

<style scoped>

</style>
